import { Checkbox } from './Checkbox'
import { TemplateItem } from '../template-item'
import { CollectionTemplateTableCell } from './CollectionTemplateTableCell'
import { CollectionTemplateTableHead } from './CollectionTemplateTableHead'
import { CollectionTemplateTableViews } from './CollectionTemplateTableViews'
import { PlusIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import clsx, { ClassValue } from 'clsx'
import { CollectionTemplateTableFooter } from './CollectionTemplateTableFooter'

export type CollectionTemplateTableProps = {
  table: TemplateItem | null
  className?: ClassValue
}

export const MIN_FIELD_WIDTH = 120

export function CollectionTemplateTable (props: CollectionTemplateTableProps) {
  const { table, className } = props

  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const [activeView, setActiveView] = useState(table?.views?.at(0))

  useEffect(() => {
    setActiveView(table?.views?.at(0))
  }, [table?.id])

  const records = new Array(5).fill(0)

  return (
    <div className={clsx(className, 'border border-neutral/40 rounded-lg py-4 px-6 manrope-regular')}>
      {table && (
        <>
          <CollectionTemplateTableViews
            activeView={activeView}
            setActiveView={setActiveView}
            views={table.views}
          />

          <div className="flex justify-between border-b border-neutral/40 items-center">
            <span className="text-xs flex items-center h-full w-fit p-2">
              Records found {records.length}
            </span>
            <button
              className="btn mx-2 btn-xs btn-ghost shadow-none disabled:bg-transparent hover:bg-base-200 hover:border-transparent"
            >
              <PlusIcon size={12} />
              Add filter
            </button>
          </div>

          <div
            className="overflow-y-auto w-full flex flex-col"
            style={{ scrollbarWidth: 'thin' }}
          >
            <div className="overflow-auto w-full" style={{ scrollbarWidth: 'thin' }}>
              <div className="min-w-full">
                <CollectionTemplateTableHead
                  fields={table.fields}
                  viewFields={activeView?.viewFields}
                  records={records}
                  selectedRecords={selectedRows}
                  setSelectedRecords={setSelectedRows}
                />

                <div id="table-content">
                  {records.map((_, i) => (
                    <div
                      key={i}
                      id={`row-${i}`}
                      className={clsx('inline-flex flex-row min-w-full border-b border-neutral/40 min-h-6', selectedRows.includes(`row-${i}`) && 'bg-info/10')}
                    >
                      <label className="group flex items-start py-1 justify-center w-8 min-h-7 cursor-pointer">
                        <Checkbox
                          className={clsx(
                            !selectedRows.includes(`row-${i}`) && 'opacity-0',
                            'hover:opacity-100',
                            'transition-opacity',
                            'duration-200',
                            'rounded-md'
                          )}
                          size="xs"
                          color="info"
                          checked={selectedRows.includes(`row-${i}`)}
                          onChange={(event: any) => {
                            if (event.currentTarget.checked) {
                              setSelectedRows(prev => {
                                return [...prev, `row-${i}`]
                              })
                            } else {
                              setSelectedRows(prev => {
                                return prev.filter(row => row !== `row-${i}`)
                              })
                            }
                          }}
                        />
                      </label>
                      {activeView?.viewFields.map((viewField, index) => (
                        <CollectionTemplateTableCell
                          key={index}
                          coordinates={{ x: i, y: index }}
                          config={viewField?.config}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <CollectionTemplateTableFooter />
          </div>

          {/* drawer aqui */}
        </>
      )}
    </div>
  )
}
